import { Component, OnInit } from '@angular/core';
import { Policy } from '../policy.model';
import { FirebaseService } from '../services/firebase.service';
import { MatCard } from '@angular/material/card';
import { MatGridList } from '@angular/material/grid-list';

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.css']
})
export class PlansComponent implements OnInit {

  plans:Array<any>;

  constructor(private fbs: FirebaseService) { 
    this.fbs.getPlans().subscribe(res=>{
      this.plans=res;
    })
  }

  ngOnInit(): void {
  }

  selectPlan(planId){
    console.log(planId);
  }

}
